import React, { Component } from 'react'
import HeaderConsumo from './components/HeaderConsumo'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import ReactLoading from 'react-loading'
import CsvDownloader from 'react-csv-downloader'
import { Link, Redirect } from 'react-router-dom'
import ReactEcharts from "echarts-for-react"
import Select from '../../components/Select'
import CurrencyInput from 'react-currency-input-field'
import ButtonsForm from '../../components/ButtonsForm'
import domToImage from 'dom-to-image'
import pdfMake from 'pdfmake'
import helper from '../../utils/helper'
import auth from '../../utils/auth'
import cfg from '../../utils/config'
import axios from 'axios'
import ConfirmDelete from '../../components/ConfirmDelete'
import { getVolumeChartGroupByMessage } from '../../utils/volumeMessages'
import GenericInputDate from '../../components/GenericInputDate'
import { formatValueLabel } from '../../utils/normalizeDateHelpers'

pdfMake.fonts = {
   Roboto: {
      normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
      bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
      italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
   }
}

const BRAZILIANREAL = new Intl.NumberFormat('pt-BR', {
   style: 'currency',
   currency: 'BRL',
})

class Form extends Component {
   userInfo = auth.getUserInfo()
   configMe = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

   state = {
      detalhesDefault: {
         descricao: "",
         unidade: { label: 'm3', value: 'm3' },
         firstPeriod: "",
         secondPeriod: "",
         agrupar: "",
         cliente: { label: 'Nenhum', value: null },
         valor_unidade: '0',
         campos: [],
      },
      validacao: { agrupar: true, descricao: true, campos: true },
      modal: false,
      optionsCliente: [],
      carregando: false,
      relatorioGerado: false,
      chart: null,
      table: null,
      csv: { data: [], columns: [], comparar_periodos: false },
      tabIndex: 0,
      mensagemAviso: "",
      periodoValido: false,
      disabledCliente: false,
      comparar_periodos: false,
      total_consumo_primeiro_periodo: 0,
      total_consumo_segundo_periodo: 0
   }

   userInfo = auth.getUserInfo()

   componentDidMount() {
      if (this.userInfo.tipo === "cliente") {

         let optionsCliente = [{ value: this.userInfo.cliente, label: this.userInfo.nome }]
         this.setState({ optionsCliente })

         if (this.props.match.params.id) {
            this.getData()
         }

      } else {
         this.getClients().then(() => {
            if (this.props.match.params.id) {
               this.getData()
            }
         })
      }
   }

   componentDidUpdate(prevProps, prevState) {
      const { detalhesDefault } = this.state

      if (prevState.detalhesDefault.agrupar !== detalhesDefault.agrupar) {
         this.validatePeriod()
      }
   }

   getData = async () => {
      await axios({
         method: 'GET',
         url: cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + `/relatorio/consumo/${this.props.match.params.id}/`,
         headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
      }).then(res => {
         let campos = []
         let { detalhesDefault, optionsCliente } = this.state

         if (res.data?.campos) {
            res.data.campos?.map((campo) => campos.push(campo))
         }

         if (Boolean(res.data.cliente)) {
            detalhesDefault['cliente'] = { label: "", value: res.data.cliente }
         }

         detalhesDefault['campos'] = campos
         detalhesDefault['descricao'] = res.data.descricao
         detalhesDefault['cliente'] = optionsCliente?.find(c => c.value == res.data?.cliente)
         this.setState({ detalhesDefault, disabledCliente: true })
      })
   }

   saveAction = () => {
      let { detalhesDefault } = this.state
      let notValid = false
      let validateForm = this.state.validacao
      let campos = []
      let verb, url

      const except = ['modal', 'firstPeriod', 'secondPeriod', 'agrupar', 'campos', 'unidade', 'cliente', 'valor_unidade']
      for (let key in detalhesDefault) {
         if (!detalhesDefault[key] && !except.includes(key)) {
            validateForm[key] = false
            notValid = true
         } else validateForm[key] = true
      }

      if (notValid === true) {
         this.setState({ validacao: validateForm })
         return
      }

      this.setState({ cooldown: true })

      detalhesDefault.campos.map(campo => campos.push(campo.id))

      const bodyFormData = new FormData()
      bodyFormData.append('descricao', detalhesDefault.descricao)
      bodyFormData.append('campos', JSON.stringify(campos))

      if (this.userInfo?.tipo == "cliente" && this.userInfo?.cliente) {
         bodyFormData.append('cliente_id', this.userInfo?.cliente)
      } else {
         if (detalhesDefault.cliente) {
            if (detalhesDefault.cliente?.value == null) {
               bodyFormData.delete('cliente_id')
            } else {
               bodyFormData.append('cliente_id', detalhesDefault.cliente?.value)
            }
         }
      }

      if (this.props.match.params.id) {
         verb = 'PATCH'
         url = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo?.empresa + `/relatorio/consumo/${this.props.match.params.id}/`
      } else {
         verb = 'POST'
         url = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo?.empresa + `/relatorio/consumo/`
      }

      axios({
         method: verb,
         url: url,
         data: bodyFormData,
         headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
      }).then((res) => {
         helper.dispatchEvent("showAviso", {
            message: "Relatorio salvo com sucesso",
            callback: () => this.setState({
               redirect: true,
               path: "/relatorio-consumo",
               relatorioGerado: false,
               chart: null,
               table: null
            }),
            callbackClose: verb === 'POST' ? () => {
               window.location.href = `/relatorio-consumo/${res.data.id}/editar`
               setTimeout(() => {
                  window.location.reload()
               }, 1000)
            } : null
         })
      })
      .catch((error) => {
         helper.dispatchEvent("showAviso", {
             message: error.response.data.cliente[0],
         })
     })

      setTimeout(() => this.setState({ cooldown: false }), 2000)
   }

   formatValue = (value) => {
      return value === null ? "---" : String(value?.toFixed(2)).replace(".", ",")
   }

   formatMoney = (value) => {
      return value === null ? "---" : BRAZILIANREAL.format(value?.toFixed(2))
   }

   formatPercent = (value) => {
      return value === null ? "---" : value + "%"
   }

   buscarDadosRelatorio = async () => {
      const { detalhesDefault, comparar_periodos } = this.state
      let dispositivos = []
      let notValid = false
      let validateForm = this.state.validacao
      let chart = { series: [], xAxis: [] }

      this.setState({ carregando: true, relatorioGerado: false, chart: null, table: null })

      const except = ['modal', 'descricao', 'secondPeriod', 'campos', 'unidade', 'cliente', 'valor_unidade']

      for (let key in detalhesDefault) {
         if (!detalhesDefault[key] && !except.includes(key)) {
            validateForm[key] = false
            notValid = true
         } else validateForm[key] = true
      }

      if (notValid) {
         validateForm["campos"] = detalhesDefault.campos.length > 0
         this.setState({ validacao: validateForm, carregando: false })
         return
      }

      if (detalhesDefault.campos.length > 0) {
         detalhesDefault.campos.map(campo => {
            const index_dispositivo = dispositivos.findIndex(dispositivo => dispositivo.id_dispositivo === campo.usuario_mqtt)

            if(index_dispositivo !== -1) {
               dispositivos[index_dispositivo].parametros.push(campo.identificacao)
            } else {
               dispositivos.push({ id_dispositivo: campo.usuario_mqtt, parametros: [campo.identificacao] })
            }
         })

         dispositivos = dispositivos.map((dispositivo) => ({ id_dispositivo: dispositivo.id_dispositivo, parametros: dispositivo.parametros.join() }))

         const body_data = {
            "dispositivos_parametros": dispositivos,
            "agrupar_por": detalhesDefault.agrupar?.value,
            "primeiro_periodo": detalhesDefault.firstPeriod,
            "segundo_periodo": comparar_periodos ? detalhesDefault.secondPeriod : {},
            "gerar_comparativo": comparar_periodos,
            "custo_por_unidade": detalhesDefault.valor_unidade.replaceAll(",", ".")
         }

         await axios({
            method: 'POST',
            url: cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo?.empresa + '/relatorio/consumo/comparativo/',
            data: body_data,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
         })
         .then(res => {
            const { grafico, tabela } = res.data

            let table = { 
               itens: tabela.dados, 
               comparar_periodos: comparar_periodos, 
               total: {
                  consumo_primeiro_periodo: tabela.consumo_total.valor_primeiro_periodo, 
                  consumo_segundo_periodo: tabela.consumo_total.valor_segundo_periodo, 
                  custo_primeiro_periodo: tabela.custo_total.valor_primeiro_periodo, 
                  custo_segundo_periodo: tabela.custo_total.valor_segundo_periodo
               } 
            }
         
            chart.xAxis = grafico.periodos
            chart.total_consumo_primeiro_periodo = grafico.total_consumo_primeiro_periodo
            chart.total_consumo_segundo_periodo = grafico.total_consumo_segundo_periodo
            chart.series.push({ type: 'line', data: grafico.valores_consumo_primeiro_periodo, color: "#3d91ff" })

            if(comparar_periodos) {
               chart.series.push({ type: 'line', data: grafico.valores_consumo_segundo_periodo, color: "#3ecf8e" })
            }

            this.formatCsv(table, detalhesDefault.valor_unidade)

            this.setState({ relatorioGerado: true, carregando: false, chart, table })
         })
         .catch(console.error)
      }

      this.setState({ carregando: false })
   }

   formatCsv = (data, custo_por_unidade) => {
      let csv = { data: [], columns: [] }

      custo_por_unidade = Number(custo_por_unidade.replace(",", "."))

      const calcTotal = (value) => {
         if(value === null) {
            return 0
         }

         return custo_por_unidade * value
      }
      
      csv.columns = [
         { id: 'c0', displayName: 'Monitorado' },
         { id: 'c1', displayName: 'Parâmetro' },
         { id: 'c2', displayName: 'Valor Inicial' },
         { id: 'c3', displayName: 'Valor Final' },
         { id: 'c4', displayName: 'Consumo (m3)' },
         { id: 'c5', displayName: 'Valor (R$)' },
         { id: 'c6', displayName: '%' }
      ]

      data.itens.forEach((item) => {
         const row_primeiro_periodo = { 
            c0: item.monitorado_referenciado,
            c1: item.parametro, 
            c2: this.formatValue(item.valor_inicial.valor_primeiro_periodo), 
            c3: this.formatValue(item.valor_final.valor_primeiro_periodo), 
            c4: this.formatValue(item.consumo.valor_primeiro_periodo),
            c5: this.formatMoney(calcTotal(item.consumo.valor_primeiro_periodo)),
            c6: this.formatPercent(item.consumo.porcentagem_do_total_primeiro)
         }

         data.comparar_periodos ? row_primeiro_periodo["c7"] = item.consumo.descricao_variacao : null

         const row_segundo_periodo = { 
            c0: "", 
            c1: "", 
            c2: this.formatValue(item.valor_inicial.valor_segundo_periodo), 
            c3: this.formatValue(item.valor_final.valor_segundo_periodo), 
            c4: this.formatValue(item.consumo.valor_segundo_periodo),
            c5: this.formatMoney(calcTotal(item.consumo.valor_segundo_periodo)),
            c6: this.formatPercent(item.consumo.porcentagem_do_total_segundo),
            c7: ""
         }

         csv.data.push(row_primeiro_periodo)

         data.comparar_periodos ? csv.data.push(row_segundo_periodo) : null
      })

      const row_total_primeiro_periodo = {
         c0: 'Total', 
         c1: "",
         c2: "", 
         c3: "", 
         c4: this.formatValue(data.total.consumo_primeiro_periodo), 
         c5: this.formatMoney(calcTotal(data.total.consumo_primeiro_periodo)),
         c6: "", 
      }

      data.comparar_periodos ? row_total_primeiro_periodo["c7"] = "" : null

      csv.data.push(row_total_primeiro_periodo)

      if(data.comparar_periodos) {
         csv.columns.push({ id: 'c7', displayName: 'Diferença' })
         csv.data.push({ c0: 'Total', c1: "", c2: "", c3: "", c4: this.formatValue(data.total.consumo_segundo_periodo), c5: this.formatMoney(calcTotal(data.total.consumo_segundo_periodo)), c6: "", c7: "" })
      }

      csv["primeiro_periodo"] = this.state.detalhesDefault.firstPeriod
      csv["segundo_periodo"] = this.state.detalhesDefault.secondPeriod
      csv["comparar_periodos"] = data.comparar_periodos

      this.setState({ csv })
   }

   formatTooltip = (params) => {
      const { detalhesDefault } = this.state

      if (Array.isArray(params)) {
         let formatted = ""
         for (let i = 0; i < params.length; i++) {
            let value = (detalhesDefault.unidade?.value == "horas") ? helper.decimalToTime(Number(params[i].data).toFixed(2)) : Number(params[i].data).toFixed(2).toLocaleString("pt-BR")
            formatted += `
            <div style="display: flex; align-items: center;">
            <div style="background-color: ${params?.[i]?.color}; height: 14px; width: 14px; border-radius: 7px; margin-right: 5px"></div>
            ${params[i]?.seriesName}:&nbsp; <b>${value}</b>
            ${(i !== (params.length - 1)) ? "</div>\n" : "</div>"}
            `
         }

         return formatted
      }

      return ""
   }

   handleChange = (key, value) => {
      let { detalhesDefault, table } = this.state

      if(key === 'periodo') {
         if (value.compare) {
            detalhesDefault.firstPeriod = {
               data_inicio: value.firstPeriod.startDate,
               data_fim: value.firstPeriod.endDate
            }
            detalhesDefault.secondPeriod = {
               data_inicio: value.secondPeriod.startDate,
               data_fim: value.secondPeriod.endDate
            }
         } else {
            detalhesDefault.firstPeriod = {
               data_inicio: value.startDate,
               data_fim: value.endDate
            }
         }

         this.setState({ comparar_periodos: value.compare ?? false })
      } else {
         detalhesDefault[key] = value
      }

      if(key === "valor_unidade") {
         if(table) {
            this.formatCsv(table, value)
         }
      }

      this.setState({ detalhesDefault }, () => {
         if (key === 'agrupar' || key === 'periodo') {
            this.validatePeriod()
         }
      })
   }

   getClients = async () => {
      await axios.get(cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/cliente/' + `?monitorado_restrito=${this.userInfo.monitorado_restrito}`, this.configMe).then(cliente => {
         let optionsCliente = []

         optionsCliente.push({ label: 'Nenhum', value: null })

         if (cliente.data?.results.length > 0) {
            cliente.data?.results?.forEach((c) => {
               optionsCliente.push({ "value": c.id, "label": c.nome_fantasia })
            })
         }

         this.setState({ optionsCliente })
      })
   }

   adicionar = (itens) => {
      let { detalhesDefault } = this.state
      let bodyFormData = new FormData()
      let campos = []

      for (let campo of itens) {
         campos.push(campo.value)
      }

      bodyFormData.append('campos', JSON.stringify(campos))

      if (this.props.match.params.id) {
         axios({
            method: 'PATCH',
            url: cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + `/relatorio/consumo/${this.props.match.params.id}/`,
            data: bodyFormData,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
         })
            .then((res) => {
               if (res.data?.campos) {
                  detalhesDefault['campos'] = itens = res.data.campos
               }

               this.setState({ detalhesDefault, relatorioGerado: false, chart: null, table: null })
               this.toggleModal()
            })
            .catch(console.error)
      } else {
         detalhesDefault['campos'] = itens
         this.setState({ detalhesDefault })
         this.toggleModal()
      }
   }

   toggleModal = () => {
      let { validacao } = this.state
      for (let key in validacao) {
         validacao[key] = true
      }

      this.setState({ validacao, modal: false })
   }

   gerarGrafico = () => {
      const { chart, detalhesDefault, table } = this.state
      const axisType = { dia: 'Dias', mes: 'Meses', hora: 'Horas', ano: "Anos", mes_dia_especificado: 'Período Específico', fixo: 'Período Fixo' }
      const labelDesc = { dia: '(Dia)', mes: '(Mês)', hora: '(Hora)', ano: "(Ano)", mes_dia_especificado: '(Período Específico)', fixo: '(Período Fixo)' }
      let series = []

      series = chart?.series?.map((serie) => {
         if (serie.data.length > 0) {
            let label = {
               show: true,
               position: 'top',
               color: "rgba(0, 0, 0, 0.85)",
               fontWeight: '600',
               textBorderColor: '#fff',
               textBorderWidth: 2,
               distance: 5,
               fontSize: 12,
               rotate: chart.xAxis.length > 20 ? 55 : 0,
               formatter: (params) => !isNaN(params.value) ? (detalhesDefault.unidade?.value == "horas") ? helper.decimalToTime(Number(Number(params.data).toFixed(2))) : Number(Number(params.data).toFixed(2)).toLocaleString("pt-BR") : (detalhesDefault.unidade?.value == "horas") ? helper.decimalToTime(Number(Number(params.value).toFixed(2))) : Number(Number(params.value).toFixed(2)).toLocaleString("pt-BR")
            }

            return {
               name: `Total ${labelDesc[detalhesDefault.agrupar?.value]}`,
               data: serie.data,
               type: serie.type,
               itemStyle: { color: serie.color, opacity: 1 },
               lineStyle: { width: 2 },
               labelLayout: { hideOverlap: true },
               label: label,
               areaStyle: {},
               stack: 'Total'
            }
         }
         return null
      }).filter(s => s !== null)

      return (
         <div className="chart-item" style={{ padding: '3px' }}>
            <h5 style={{ textAlign: 'center' }}>Relatório de Consumo</h5>

            <div className="d-flex justify-content-between mt-2">
               <div class="d-flex flex-row" style={{gap: "0.5rem"}}>
                  <label style={{
                     fontSize: "20px",
                  }}>
                     <i
                        className="las la-info-circle"
                        style={{ cursor: "pointer" }}
                        title={getVolumeChartGroupByMessage(detalhesDefault?.agrupar?.value)?.title}
                        onClick={() => helper.dispatchEvent("showAviso", {
                           message: getVolumeChartGroupByMessage(detalhesDefault?.agrupar?.value)?.message
                        })}
                     >
                     </i>
                  </label>
                  <strong style={{ fontSize: '20px' }}>Consumo Total</strong>
               </div>
               <div className='d-flex flex-col align-items-end'>
                  <span style={{ fontSize: '20px', fontWeight: 'bold', color: "#75b0fe" }}>
                     {(detalhesDefault.unidade?.value == "horas") ? helper.decimalToTime(chart.total_consumo_primeiro_periodo) : this.formatValue(chart.total_consumo_primeiro_periodo)}
                     {detalhesDefault.unidade?.value ? ` (${detalhesDefault.unidade?.value})` : null}
                  </span>
                  <span style={{ fontSize: '20px', fontWeight: 'bold', color: "#70dcad", display: table.comparar_periodos ? "block" : "none" }}>
                     {(detalhesDefault.unidade?.value == "horas") ? helper.decimalToTime(chart.total_consumo_segundo_periodo) : this.formatValue(chart.total_consumo_segundo_periodo)}
                     {detalhesDefault.unidade?.value ? ` (${detalhesDefault.unidade?.value})` : null}
                  </span>
               </div>
            </div>
            <div className="hdv-chart">
               {series?.length > 0 ?
                  <ReactEcharts
                     style={{ height: '360px', width: '100%' }}
                     option={{
                        series: series,
                        xAxis: {
                           data: chart?.xAxis,
                           name: axisType[detalhesDefault.agrupar.value],
                           nameTextStyle: { fontWeight: '600', fontSize: '12' },
                           nameLocation: 'center',
                           nameGap: 22
                        },
                        yAxis: {
                           type: 'value',
                           max: (value) => {
                              if (value?.max < 0)
                                 return Math.ceil((value.max + (Math.abs(value.max) * 0.1)))
                              return Math.ceil((value.max + (Math.abs(value.max) * 0.1)))
                           },
                           min: (value) => Math.floor(value.min - (Math.abs(value.min) * 0.6)),
                        },
                        grid: { left: 60, right: 20, bottom: 60 },
                        tooltip: {
                           show: true,
                           trigger: "axis",
                           axisPointer: { type: "shadow", label: { show: true } },
                           formatter: (params) => this.formatTooltip(params)
                        }
                     }} />
                  :
                  <p style={{ margin: '12px 0', textAlign: 'center', color: '#a33131', fontWeight: 'bold' }}>Erro ao carregar gráfico</p>
               }
            </div>
            <hr />
         </div>
      )
   }

   getBase64ImageFromURL = (url) => {
      return new Promise((resolve, reject) => {
         let img = new Image()
         img.setAttribute("crossOrigin", "anonymous")

         img.onload = () => {
            let canvas = document.createElement("canvas")
            canvas.width = img.width
            canvas.height = img.height

            let ctx = canvas.getContext("2d")
            ctx.drawImage(img, 0, 0)

            let dataURL = canvas.toDataURL("image/png")

            resolve(dataURL)
         }

         img.onerror = error => reject(error)

         img.src = url
      })
   }

   exportarPDF = async () => {
      const { detalhesDefault, csv } = this.state
      let chart = true
      let logo = true

      let infoEmpresa
      await axios.get(cfg.base_api_url + cfg.api_v2 + `/${this.userInfo.empresa}/configuracao-sistema`, this.configMe).then(res => { infoEmpresa = res.data?.data })

      let periodo_formatado = formatValueLabel({
         startDate: csv.primeiro_periodo.data_inicio,
         endDate: csv.primeiro_periodo.data_fim
      })
      let segundo_periodo_formatado = ""

      if (csv.comparar_periodos) {
         segundo_periodo_formatado = formatValueLabel({
            startDate: csv.segundo_periodo.data_inicio,
            endDate: csv.segundo_periodo.data_fim
         })
      }

      csv.comparar_periodos ?  periodo_formatado = periodo_formatado + " vs " + segundo_periodo_formatado : null

      let widths
      if (csv.comparar_periodos) {
         widths = ["15%", "15%", "12%", "12%", "12%", "14%", "12%", "8%"]
      } else {
         widths = ["15%", "15%", "15%", "15%", "15%", "15%", "10%"]
      }
      
      const header_table = csv.columns.map((item) => ({ text: item.displayName, alignment: 'center', fillColor: '#b7b7b7' }))
      const data_table = csv.data.map((item) =>  {

         const values = Object.entries(item)

         return values.map((value) => {
            const key = value[0]
            const value_col = value[1]

            let colSpan = value_col === "Total" ? 3 : 1
            let rowSpan = 1
            let color = values[0][1] === "Total" ? '#d5d5d5' : "#fff"

            if (csv.comparar_periodos) {
               if (key === 'c0' && value_col === "Total") {
                  colSpan = 1
                  rowSpan = 2
               }
            } else {
               if (key === 'c0' && value_col === "Total") {
                  colSpan = 3
                  rowSpan = 1
               }
            }
            
            return { text: value_col, colSpan: colSpan, rowSpan: rowSpan, fillColor: color }
         })
      })
      const body = [
         header_table,
         ...data_table
      ]

      let header = []
      let content = [
         {
            columns: [
               {
                  width: '*',
                  text: 'Relatório de Consumo',
                  margin: [0, 50, 0, 0],
                  fontSize: 18,
                  bold: true,
               },
               {
                  width: 360,
                  margin: [0, 0, 10, 0],
                  alignment: 'right',
                  text: [infoEmpresa?.email_contato, '\n', infoEmpresa?.endereco, '\n', infoEmpresa?.telefone, "\n"]
               },
               (logo) ? {
                  width: 100,
                  heigth: 100,
                  image: await this.getBase64ImageFromURL(document.querySelector('div.hdv-logomarca img').src),
               } : null,
            ]
         }, {
            text: ".",
            color: "white"
         }, {
            text: ".",
            color: "white"
         }, {
            table: {
               headerRows: 1,
               widths: ["*"],
               body: [
                  ["Relatório: " + detalhesDefault?.descricao + " - Período: " + periodo_formatado],
               ]
            },
            layout: {
               hLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? 2 : 1
               },
               vLineWidth: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? 2 : 1
               },
               hLineColor: function (i, node) {
                  return (i === 0 || i === node.table.body.length) ? 'black' : 'gray'
               },
               vLineColor: function (i, node) {
                  return (i === 0 || i === node.table.widths.length) ? 'white' : 'white'
               },
            }
         }, {
            text: ".",
            color: "white"
         }, {
            columns: [
               (chart) ? {
                  width: 821,
                  heigth: 500,
                  image: await domToImage.toPng(document.querySelector('.chart-item')),
               } : null,
            ]
         }, {
            text: ".",
            color: "white"
         }, {
            style: 'tableConsumo',
            color: '#444',
            fontSize: 10,
            table: {
               widths: widths,
               headerRows: 1,
               body: body
            }
         },
      ]
      let footer = []

      let fileDefinition = {
         pageSize: 'A4',
         pageOrientation: 'landscape',
         pageMargins: [10, 10, 10, 20],
         header: [header],
         content: [content],
         styles: { tableConsumo: { margin: [0, 120, 0, 0] }, },
         footer: [footer],
      }

      pdfMake.createPdf(fileDefinition).open()

   }

   validatePeriod = () => {
      const { detalhesDefault, comparar_periodos } = this.state

      const primeiro_periodo_inicio = detalhesDefault?.firstPeriod?.data_inicio * 1000
      const primeiro_periodo_fim = detalhesDefault?.firstPeriod?.data_fim * 1000
      const primeiro_periodo_dias = Math.ceil((primeiro_periodo_fim - primeiro_periodo_inicio) / (1000 * 60 * 60 * 24))

      const segundo_periodo_inicio = detalhesDefault?.secondPeriod?.data_inicio * 1000
      const segundo_periodo_fim = detalhesDefault?.secondPeriod?.data_fim * 1000
      const segundo_periodo_dias = Math.ceil((segundo_periodo_fim - segundo_periodo_inicio) / (1000 * 60 * 60 * 24))

      let mensagemAviso = ""
      let periodoValido = true

      if(comparar_periodos) {
         if(primeiro_periodo_dias > segundo_periodo_dias || primeiro_periodo_dias < segundo_periodo_dias) {
            mensagemAviso = "Os periodos comparativos devem ter a mesma quantidade de dias."
            periodoValido = false
            this.setState({ mensagemAviso, periodoValido })
            return
         }
      }

      const condition = (value) => comparar_periodos ? primeiro_periodo_dias > value || segundo_periodo_dias > value : primeiro_periodo_dias > value

      switch (detalhesDefault.agrupar?.value) {
         case 'hora':
            if (condition(1)) {
               mensagemAviso = "O período selecionado é muito grande para o agrupamento por hora. Limite de 1 dia."
               periodoValido = false
            }
            break
         case 'dia':
            if (condition(31)) {
               mensagemAviso = "O período selecionado é muito grande para o agrupamento por dia. Limite de 31 dias."
               periodoValido = false
            }
            break
         case 'mes':
            if (condition(366)) {
               mensagemAviso = "O período selecionado é muito grande para o agrupamento por mês. Limite de 12 meses."
               periodoValido = false
            }
            break
         case 'mes_dia_especificado':
            if (condition(366)) {
               mensagemAviso = "O período selecionado é muito grande para o agrupamento por mês. Limite de 12 meses."
               periodoValido = false
            }
            break
         default:
            break
      }

      this.setState({ mensagemAviso, periodoValido })
   }

   changeDate = (objectDate) => {
      const { detalhesDefault } = this.state
      detalhesDefault.data = objectDate
      this.setState({ detalhesDefault: detalhesDefault }, this.validatePeriod)
   }

   deleteParametro = (keyDelete) => {
      const detalhes = Object.assign({}, this.state.detalhesDefault)
      detalhes.campos = detalhes.campos.filter((campo, index) => index !== keyDelete)
      this.setState({ detalhesDefault: detalhes })
   }

   renderTable = () => {
      const { detalhesDefault } = this.state
      const { comparar_periodos, itens, total } = this.state.table
      const valor_unidade = Number(detalhesDefault.valor_unidade.replace(",", "."))

      if(itens.length === 0) return

      const row = (field, item) => {
         const segundoPeriodo = field === "valor_segundo_periodo"
         const aumento_variacao_percentual = item.consumo.tipo_variacao === "aumento"

         if(!comparar_periodos && segundoPeriodo) return

         const style_td = { color: segundoPeriodo ? "#70dcad": "#75b0fe", fontWeight: "bold" }

         return (
            <tr>
               {!segundoPeriodo ? <td rowSpan={comparar_periodos ? 2 : 1}>{item.parametro_formatado}</td> : null}
               <td style={style_td}>{this.formatValue(item.valor_inicial[field])}</td>
               <td style={style_td}>{this.formatValue(item.valor_final[field])}</td>
               <td style={style_td}>{detalhesDefault.unidade?.value == "horas" ? helper.decimalToTime(item.consumo[field]) : this.formatValue(item.consumo[field])}</td>
               <td style={style_td}>{this.formatMoney(valor_unidade * item.consumo[field])}</td>
               <td colSpan="3" style={style_td}>
                  <span className="d-flex align-items-center">
                     <progress value={segundoPeriodo ? item.consumo.porcentagem_do_total_segundo : item.consumo.porcentagem_do_total_primeiro} max="100"></progress>
                     <span className="ml-1"> {segundoPeriodo ? item.consumo.porcentagem_do_total_segundo : item.consumo.porcentagem_do_total_primeiro}%</span>
                  </span>
               </td>
               {
                  comparar_periodos && !segundoPeriodo ? 
                     <td rowSpan={comparar_periodos ? 2 : 1} style={{ color: aumento_variacao_percentual ? "#44bb52" : "#f4be1b", fontWeight: "bold" }}>
                        {item.consumo.descricao_variacao}
                     </td> 
                  : null}
            </tr>
         ) 
      } 

      const row_total = (field, index) => {
         if(index !== itens.length - 1) return

         const segundoPeriodo = field === "segundo_periodo"

         if(!comparar_periodos && segundoPeriodo) return

         const consumo = total[`consumo_${field}`]

         const style_td = { color: segundoPeriodo ? "#70dcad": "#75b0fe", fontWeight: "bold" }

         return (
            <tr>
               <td colSpan="3"><strong>Total</strong></td>
               <td style={style_td}>
                  {detalhesDefault.unidade?.value == "horas" ? helper.decimalToTime(consumo) : this.formatValue(consumo)}
               </td>
               <td style={style_td}>
                  {this.formatMoney(valor_unidade * consumo)}
               </td>

               <td colSpan="4" style={style_td}>
                  {consumo > 0
                     ?
                     <span className="d-flex align-items-center">
                        <progress value="100" max="100"></progress> <span className="ml-1">100%</span>
                     </span>
                     :
                     <span className="d-flex align-items-center">
                        <progress value="0" max="100"></progress> <span className="ml-1">100%</span>
                     </span>
                  }
               </td>
            </tr>
         )
      }

      return(
         <table className="table afira-table">
            <thead>
               <tr>
                  <th>Parâmetro</th>
                  <th>Valor Inicial</th>
                  <th>Valor Final</th>
                  <th>Consumo ({detalhesDefault?.unidade?.value})</th>
                  <th>Valor (R$)</th>
                  <th colSpan="3" style={{ width: "300px", fontWeight: "bold" }}>%</th>
                  {comparar_periodos ? <th>Diferença</th> : null}
               </tr>
            </thead>
            <tbody>
               {
                  itens.map((item, index) => (
                     <React.Fragment key={index}>
                        {row("valor_primeiro_periodo", item)}
                        {row("valor_segundo_periodo", item)}
                        {row_total("primeiro_periodo", index)}
                        {row_total("segundo_periodo", index)}
                     </React.Fragment>
                  ))
               }
            </tbody>
         </table>
      )
   }

   render() {
      const { detalhesDefault, validacao, relatorioGerado, disabledCliente, error_periodo } = this.state

      let equipamentos = []
      detalhesDefault?.campos?.forEach(campo => {
         if (!equipamentos.includes(campo?.equipamento_imei)) {
            equipamentos.push(campo?.equipamento_imei)
         }
      })

      if (this.state.redirect)
         return <Redirect to="/relatorio-consumo" />

      return (
         <div>
            <div className="hdv-default-header mx-3">
               <span className="screen-menu-desc">
                  <h4>Relatório de Consumo</h4>
                  <div className="gray-background">
                     <i className="fa fa-history fa-2x"></i>
                  </div>
               </span>
               {this.state.carregando
                  ?
                  <ReactLoading className="hdv-report-loading" type="cylon" color="var(--background-menu)" width={50} />
                  :
                  null
               }
            </div>
            <Tabs
               selectedIndex={this.state.tabIndex}
               onSelect={tabIndex => this.setState({ tabIndex })}>
               <TabList>
                  <Tab>Configuração</Tab>
                  <Tab disabled={this.props.match.params.id ? false : true}>Parâmetros</Tab>
               </TabList>
               <TabPanel>
                  {
                     this.props.match.params.id ?
                        <details open={true} className="custom-summary">
                           <summary>Filtros</summary>
                           <div style={{ padding: "20px" }} className="hdv-form-default">
                              <div className='row'>
                                 <div className="col-md-5">
                                    <label className="required mt-0">Descrição</label>
                                    <input
                                       type="text"
                                       onChange={(e) => this.handleChange('descricao', e.target.value)}
                                       value={detalhesDefault.descricao}
                                    />
                                    {!this.state.validacao.descricao ? <span id='validacao-descricao'>Campo Obrigatório</span> : null}
                                 </div>

                                 {this.userInfo?.tipo != "cliente"
                                    ?
                                    <div className="col-md-3 pl-0">
                                       <label className="required mt-0">Cliente</label>
                                       <Select
                                          disabled={disabledCliente}
                                          value={detalhesDefault.cliente}
                                          onChange={(e) => this.handleChange('cliente', e)}
                                          options={this.state.optionsCliente}
                                       />
                                    </div>
                                    :
                                    <div className="col-md-3 pl-0"></div>
                                 }
                                 <div className="col-md-2 pl-0">
                                    <label className="required mt-0">Unidade do Gráfico</label>
                                    <Select
                                       value={detalhesDefault.unidade}
                                       onChange={(e) => this.handleChange('unidade', e)}
                                       options={[
                                          { label: 'm3', value: 'm3' },
                                          { label: 'kW', value: 'kW' },
                                          { label: 'kW/h', value: 'kW/h' },
                                          { label: 'horas', value: 'horas' },
                                       ]}
                                    />
                                 </div>
                                 <div className="col-md-2 pl-0">
                                    <label className="required mt-0">Custo por Unidade</label>
                                    <CurrencyInput
                                       id="value-unidade"
                                       name="value-unidade"
                                       placeholder=""
                                       decimalsLimit={4}
                                       groupSeparator={''}
                                       decimalSeparator={','}
                                       intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
                                       style={{ border: '1px solid #d0d0d0' }}
                                       prefix={'R$ '}
                                       value={detalhesDefault.valor_unidade}
                                       onValueChange={(value, name) => { this.handleChange('valor_unidade', (value == undefined) ? '0' : value) }}
                                    />
                                 </div>
                              </div>

                              <div style={{ marginTop: "10px" }} className={this.props.match.params.id ? "row" : "hdv-noshow-item"}>
                                 <div className="col-md-6">
                                    <label className="required">Periodo</label>
                                    <GenericInputDate
                                       onChange={(value) => this.handleChange('periodo', value)}
                                       isCompare
                                       haveInitialValue
                                    />
                                 </div>

                                 <div className="col-md-6">
                                    <label className="required">Agrupar por</label>
                                    <Select
                                       value={this.state.detalhesDefault.agrupar}
                                       onChange={(e) => this.handleChange('agrupar', e)}
                                       options={[
                                          { label: 'Hora', value: 'hora' },
                                          { label: 'Dia', value: 'dia' },
                                          { label: 'Mês', value: 'mes' },
                                          { label: 'Ano', value: 'ano' },
                                          { label: 'Período Específico (Dia X do mês selecionado até o mesmo dia do mês seguinte)', value: 'mes_dia_especificado' },
                                          { label: 'Período Fixo', value: 'fixo' }
                                       ]}
                                    />
                                    {!this.state.validacao.agrupar ? <span id='validacao-agrupar'>Campo Obrigatório</span> : null}
                                 </div>
                              </div>
                              {this.state.mensagemAviso && (
                                 <div style={{ color: 'white', marginTop: '10px', width: "100%", backgroundColor: "tomato", padding: "5px", borderRadius: "5px" }}>
                                    {this.state.mensagemAviso}
                                 </div>
                              )}
                           </div>
                        </details>
                        :
                        <form className="hdv-form-default">
                           <div className='row'>
                              <div className="col-md-8">
                                 <label className="required mt-0">Descrição</label>
                                 <input
                                    type="text"
                                    onChange={(e) => this.handleChange('descricao', e.target.value)}
                                    value={detalhesDefault.descricao}
                                 />
                                 {!this.state.validacao.descricao ? <span id='validacao-descricao'>Campo Obrigatório</span> : null}
                              </div>

                              {this.userInfo?.tipo != "cliente"
                                 ?
                                 <div className="col-md-4 pl-0">
                                    <label className="required mt-0">Cliente</label>
                                    <Select
                                       value={detalhesDefault.cliente}
                                       onChange={(e) => this.handleChange('cliente', e)}
                                       options={this.state.optionsCliente}
                                    />
                                 </div>
                                 :
                                 <div className="col-md-3 pl-0"></div>
                              }
                           </div>
                        </form>
                  }
               </TabPanel>
               <TabPanel>
                  <div className="hdv-multi-report-dispositivos">
                     <div>
                        <button
                           className="hdv-btn-forms hdv-btn-green"
                           disabled={this.state.carregando}
                           style={{ position: "relative", width: "100%", height: "50px", background: "var(--fonte_titulo_abas)", margin: "0px" }}
                           onClick={() => this.setState({ modal: true })}>
                           Gerenciar Parâmetros
                        </button>
                        <p style={{ display: !validacao.campos ? "block" : "none", color: 'white', marginTop: '5px', width: "100%", backgroundColor: "tomato", padding: "5px", borderRadius: "5px", textAlign: "center", fontWeight: "bold" }}>Nenhum Parâmetro registrado</p>
                     </div>

                     {
                        detalhesDefault.campos?.length > 0 ?
                           detalhesDefault.campos?.map((campo, index) => {
                              let icone = ""
                              let monitorados = []
                              let monitorados_text = ""

                              campo.monitorados.forEach((monitorado) => {
                                 monitorados.push(monitorado.monitorado_nome)
                              })

                              monitorados_text = monitorados.join()

                              try {
                                 icone = JSON.parse(campo?.icone)?.icone_on
                              } catch (err) {
                                 icone = null
                              }

                              return (
                                 <details style={{ margin: "10px 0px" }} key={index} className="hdv-relatorio-chart" open={false}>
                                    <summary style={{ backgroundColor: "#eeeeee", padding: "10px", borderRadius: "5px" }}>
                                       <div className="d-flex justify-content-between align-items-center">
                                          <div className="d-flex align-items-center">
                                             <i
                                                style={{ fontSize: "20px" }}
                                                className={icone != null ? `fa ${icone} mr-1` : ""}></i>
                                             <span>{campo.descricao} [{campo.identificacao}]</span>
                                          </div>

                                          {
                                             <ConfirmDelete
                                                enabled={true}
                                                action={() => this.deleteParametro(index)}
                                                type="parametro"
                                             />
                                          }
                                       </div>
                                    </summary>

                                    <div id="hdv-content">
                                       <span><strong>Monitorado(s):</strong> {monitorados_text}</span>
                                       <span><strong>Parâmetro:</strong> {campo.descricao} [{campo.identificacao}]</span>
                                       <span><strong>Unidade de medida:</strong> {campo.unidade}</span>
                                    </div>
                                 </details>
                              )
                           })
                           : null
                     }
                  </div>
               </TabPanel>
            </Tabs>

            {detalhesDefault.descricao
               ?
               <HeaderConsumo
                  DataChange={detalhesDefault}
                  toggleModal={this.toggleModal}
                  adicionar={this.adicionar}
                  validacao={validacao}
                  clientes={this.state.optionsCliente}
                  modal={this.state.modal}
                  handleChange={this.handleChange}
               />
               :
               null
            }

            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
               <div style={{ display: !this.props.match.params.id ? "none" : "flex" }} className="hdv-btn-group">
                  <button
                     disabled={this.state.carregando || !this.props.match.params.id || !this.state.periodoValido}
                     className="hdv-btn-forms hdv-btn-blue"
                     onClick={this.buscarDadosRelatorio}>
                     Gerar Relatório
                  </button>

                  <CsvDownloader
                     style={{ border: 'none' }}
                     columns={this.state.csv.columns}
                     datas={this.state.csv.data}
                     filename={`relatorio_consumo_${detalhesDefault?.descricao.replace(/[^a-zA-Z0-9]/g, '_')}.csv`}
                     separator=";">
                     <button disabled={!this.state.relatorioGerado || !this.state.periodoValido} className="hdv-btn-forms hdv-btn-green ">Exportar CSV</button>
                  </CsvDownloader>

                  <button
                     disabled={!this.state.relatorioGerado || !this.state.periodoValido}
                     className="hdv-btn-forms hdv-btn-red"
                     onClick={this.exportarPDF}>
                     <i className="fa fa-file-pdf-o fa-20px"></i> Exportar PDF
                  </button>
               </div>

               <div className="hdv-btn-group">
                  <ButtonsForm
                     route="/relatorio/consumo"
                     edit={this.props.match.params.id ? true : false}
                     cooldown={this.state.cooldown}
                     buttons={[
                        {
                           method: "post",
                           button: <button onClick={this.saveAction} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                        }, {
                           method: "patch",
                           button: <button onClick={this.saveAction} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                        },
                     ]}
                  />

                  <Link to="/relatorio-consumo">
                     <button disabled={this.state.cooldown} style={{ margin: "0px" }} className="hdv-btn-forms hdv-btn-yellow">Cancelar</button>
                  </Link>
               </div>
            </div>

            {relatorioGerado ?
               <section id="hdv-multi-report-print" className="mb-4">
                  <div className="hdv-relatorio-consumo col-md-12 mx-0 mt-3" style={{ padding: '8px 0' }}>
                     {this.gerarGrafico()}
                  </div>
                  {this.renderTable()}
               </section>
               : null
            }

         </div>
      )
   }
}

export default Form
